import dayjs from 'dayjs';

import { TransactionsFilters } from './store.model';

export type GetTransactionsReq = TransactionsFilters;

export function adaptDateRangeForTransactionsApi(filters: TransactionsFilters): TransactionsFilters {
  if (!filters?.createdGte) {
    return filters;
  }

  const dateEnd = filters.createdLt ? dayjs.unix(filters.createdLt) : dayjs.unix(filters.createdGte);
  const dateEndInclusive = dateEnd.add(1, 'd').subtract(1, 's');
  const createdLt = dateEndInclusive.unix();

  return { ...filters, createdLt };
}
